import React, { useState, useEffect } from 'react';
import './Subtractions.css';

const allQuestions = [
  { question: '5+3=?', options: ['9', '8', '2', '7'], answer: '8' },
  { question: '4+1=?', options: ['3', '4', '5', '6'], answer: '5' },
  { question: '3+2=?', options: ['5','6','1','4'], answer: '5' },
  { question: '7+4=?', options: ['11', '12', '13', '14'], answer: '11' },
  { question: '9+6=?', options: ['11', '12', '15', '14'], answer: '15' },
  { question: '8+2=?', options: ['11', '10', '6', '12'], answer: '10' },
  { question: '6+1=?', options: ['8', '5', '6', '7'], answer: '7' },
  { question: '10+7=?', options: ['17', '12', '3', '11'], answer: '17' },
  { question: '2+1=?', options: ['1', '2', '3', '4'], answer: '3' },
  { question: '6+3=?', options: ['3', '9', '11', '8'], answer: '9' },
  { question: '10+3=?', options: ['16', '8', '15', '13'], answer: '13' },
  { question: '8+5=?', options: ['13', '14', '15', '16'], answer: '13' },

  { question: '3+3=?', options: ['7', '9', '6', '3'], answer: '6' },
  { question: '4+2=?', options: ['7', '4', '6', '2'], answer: '6' },
  { question: '9+2=?', options: ['11', '17', '18', '19'], answer: '11' },
  { question: '7+0=?', options: ['1', '0', '7', '2'], answer: '7' },
  { question: '9+1=?', options: ['10', '12', '8', '16'], answer: '10' },
  { question: '8+4=?', options: ['14', '15', '16', '12'], answer: '12' },
  { question: '6+5=?', options: ['14', '15', '16', '11'], answer: '11' },
  { question: '10+10=?', options: ['10', '20', '30', '0'], answer: '20' },
  { question: '9+7=?', options: ['16', '18', '17', '14'], answer: '16' },
  { question: '6+4=?', options: ['13', '10', '15', '16'], answer: '10' },

  { question: '13+3=?', options: ['16', '12', '10', '13'], answer: '16' },
  { question: '14+2=?', options: ['13', '14', '11', '16'], answer: '16' },
  { question: '19+2=?', options: ['16', '21', '23', '19'], answer: '21' },
  { question: '17+0=?', options: ['11', '10', '17', '12'], answer: '17' },
  { question: '19+1=?', options: ['21', '20', '18', '16'], answer: '20' },
  { question: '18+4=?', options: ['24', '22', '16', '27'], answer: '22' },
  { question: '16+5=?', options: ['14', '15', '21', '31'], answer: '21' },
  { question: '20+10=?', options: ['10', '20', '30', '0'], answer: '30' },
  { question: '19+1=?', options: ['11', '18', '20', '14'], answer: '20' },
  { question: '16+5=?', options: ['13', '21', '15', '16'], answer: '21' },

  { question: '33+13=?', options: ['41', '40', '48', '46'], answer: '46' },
  { question: '24+12=?', options: ['33', '44', '36', '42'], answer: '36' },
  { question: '99+12=?', options: ['111', '112', '101', '121'], answer: '111' },
  { question: '37+10=?', options: ['46', '50', '47', '22'], answer: '47' },
  { question: '39+11=?', options: ['40', '50', '60', '70'], answer: '50' },
  { question: '78+74=?', options: ['150', '151', '152', '153'], answer: '152' },
  { question: '66+55=?', options: ['114', '115', '126', '121'], answer: '121' },
  { question: '100+20=?', options: ['90', '120', '70', '80'], answer: '120' },
  { question: '99+91=?', options: ['180', '178', '167', '190'], answer: '190' },
  { question: '66+65=?', options: ['131', '111', '121', '116'], answer: '131' },
];

const getRandomQuestions = (num) => {
  const shuffled = [...allQuestions].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, num);
};

const Addition = () => {
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedOption, setSelectedOption] = useState('');
  const [isAnswered, setIsAnswered] = useState(false);
  const [score, setScore] = useState(0);
  const [showScore, setShowScore] = useState(false);

  useEffect(() => {
    setQuestions(getRandomQuestions(10));
  }, []);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsAnswered(true);
    if (selectedOption === questions[currentQuestion].answer) {
      setScore(score + 1);
    }
  };

  const handleNextQuestion = () => {
    const nextQuestion = currentQuestion + 1;
    if (nextQuestion < questions.length) {
      setCurrentQuestion(nextQuestion);
      setIsAnswered(false);
      setSelectedOption('');
    } else {
      setShowScore(true);
    }
  };
  const openUrl = () => {
    window.open('https://draftj.in', '_blank');
}
const clearBoard = () => {
    // setBoard([...originalBoard]);
    window.location.reload();
   };
  return (
    <div className="Apps">
      <h1>Addition Quiz &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<button onClick={openUrl}>Home</button> &nbsp;&nbsp;&nbsp;&nbsp;<button onClick={clearBoard}>Start Quiz Again</button></h1>
      {showScore ? (
        <div className="score-section">
          Your score: {score} out of {questions.length}
        </div>
      ) : (
        questions.length > 0 && (
          <div className="question-section">
            <div className="question-text">
              {questions[currentQuestion].question}
            </div>
            <form onSubmit={handleSubmit}>
              {questions[currentQuestion].options.map((option, index) => (
                <div key={index}>
                  <input
                    type="radio"
                    id={`option-${index}`}
                    name="option"
                    value={option}
                    checked={selectedOption === option}
                    onChange={handleOptionChange}
                    disabled={isAnswered}
                  />
                  <label htmlFor={`option-${index}`}>{option}</label>
                </div>
              ))}
              {!isAnswered && <button type="submit">Submit</button>}
            </form>
            {isAnswered && (
              <div className="answer-section">
                {selectedOption === questions[currentQuestion].answer ? (
                  <p>Correct!</p>
                ) : (
                  <p>Wrong! The correct answer is {questions[currentQuestion].answer}.</p>
                )}
                <button onClick={handleNextQuestion}>Next Question</button>
              </div>
            )}
          </div>
        )
      )}
    </div>
  );
};

export default Addition;
